import { Pipe, PipeTransform } from '@angular/core';
import { StringUtil } from '../util/StringUtil.model';

@Pipe({
  name: 'camelCase'
})
export class CamelCasePipe implements PipeTransform {

  transform(value: string, ...args: any[]): any {
    return StringUtil.getStringCamelCase(value);
  }
}
